<template>
  <div>
    <div class="goback-bar-cla">
      <div class="goBack" @click="goBack">
        <i class="goback-icon-cla"></i>
        <span>{{ $t('developer.goback') }}</span>
      </div>
    </div>

    <div class="appInfo_box">
      <div class="logo-box-cla">
        <div class="logo_left_cla">
          <el-upload
            class="avatar-uploader"
            action="/apiv1/pioneer/app/uploadAppIcon"
            :show-file-list="false"
            :data="data"
            :on-success="handleAvatarSuccess"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="appLog" :src="appLog" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div class="edit-header-img-cla">
              <i class="el-icon-edit"></i>
            </div>
          </el-upload>
        </div>
        <div class="logo_right_cla">
          <div style="display:flex;justify-content:space-between">
            <span class="app-name_cla">{{ appInfo.name }}</span>
            <i class="el-icon-edit app_edit_cla" @click="editApp"></i>
          </div>
          <div class="logo-app-des">
            {{ $t('developer.appDes') }}： {{ appInfo.des }}
          </div>
        </div>
      </div>
      <div class="appKey_box">
        <p>AppKey</p>
        <span>{{ appInfo.appKey }}</span>
      </div>
      <div class="appSecret_box">
        <div style="width:80%">
          <p>AppSecret</p>
          <span>{{ appSecret }}</span>
        </div>
        <div class="appSecret-left">
          <i
            class="show-app-secret"
            :class="
              isShow ? 'iconfont zk-icon-kejian' : 'iconfont zk-icon-bukejian'
            "
            :title="
              isShow ? $t('developer.visiable') : $t('developer.disvisible')
            "
            @click="showAppSecret"
          ></i>
          <i
            @click.stop="resetAppSecret"
            class="reset-btn-cla zk-icon-lixian"
            style="color:#4db22f"
            :title="$t('developer.reset')"
          ></i>
        </div>
      </div>
      <div class="endPoint_box">
        <p>EndPoint</p>
        <span>{{ isEmpty(endPoint) }}</span>
      </div>
    </div>

    <el-dialog
      :title="$t('license.titles')"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="closeCodeDailog"
    >
      <el-form
        :model="codeForm"
        :rules="rules"
        ref="codeForm"
        label-width="120px"
      >
        <el-row :gutter="10">
          <el-col :span="18" v-if="isEmail">
            <el-form-item :label="$t('developer.mail')">
              <el-input v-model="email" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18" v-else>
            <el-form-item :label="$t('developer.phone')">
              <el-input v-model="phone" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button
              type="primary"
              @click="changeWay"
              :disabled="!isChange"
              >{{ $t('developer.changeWay') }}</el-button
            >
          </el-col>

          <el-col :span="18">
            <el-form-item :label="$t('developer.code')" prop="code">
              <el-input
                v-model.trim="codeForm.code"
                :placeholder="$t('common.emailCodes')"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <timing
              :status="status"
              @toGetCode="toGetCode"
              ref="timing"
            ></timing>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCodeDailog">
          {{ $t('common.cancel') }}</el-button
        >
        <el-button type="primary" @click="submitCode">
          {{ $t('common.confirm') }}</el-button
        >
      </span>
    </el-dialog>

    <appInfoDailog
      ref="appInfoDailog"
      :title="title"
      :appForm="appForm"
      @enterApp="enterApp"
    ></appInfoDailog>

    <div class="appDeatil">
      <el-tabs v-model="activeName">
        <el-tab-pane v-if="hasPermission('c6f91d4dd2f343a9ba6c21095aabafd6')" :label="this.$t('developer.dashboard')" name="first">
          <dashboard
            v-if="activeName === 'first'"
            :appInfo="appInfo"
            @toDataTransferStation="activeName = 'fourth'"
          ></dashboard>
        </el-tab-pane>
        <el-tab-pane v-if="hasPermission('342e40cc4bc4451095bfa7d442e0eee2')"  :label="$t('developer.newsSub')" name="second">
          <appMessage
            v-if="activeName === 'second'"
            :appInfo="appInfo"
          ></appMessage>
        </el-tab-pane>
        <el-tab-pane v-if="hasPermission('3fb6e4dd87e243db809ad69ecf069c50')" :label="this.$t('developer.pushSetting')" name="third">
          <appSetting
            v-if="activeName === 'third'"
            :appInfo="appInfo"
          ></appSetting>
        </el-tab-pane>
        <el-tab-pane
        v-if="hasPermission('6edd9ff63ccf42b08b09271d0dcfd706')"
          :label="this.$t('developer.dataTransferStation')"
          name="fourth"
        >
          <pushDataList
            v-if="activeName === 'fourth'"
            :appInfo="appInfo"
          ></pushDataList>
        </el-tab-pane>
        <el-tab-pane v-if="hasPermission('2e8b1161168e4312be784c31c6d7ad3e')"  :label="this.$t('developer.apiLog')" name="Fifth">
          <ApiLog
            :appLog="true"
            :appInfo="appInfo"
            v-if="activeName === 'Fifth'"
          ></ApiLog>
        </el-tab-pane>
        <el-tab-pane v-if="hasPermission('79b6d7ab284d4a809ef60e03810adb46')"  :label="this.$t('appSetting.deviceCommand')" name="Sixth">
          <DeviceCommand
            :appKey="appKey"
            v-if="activeName === 'Sixth'"
          ></DeviceCommand>
        </el-tab-pane>
        <!-- v-if="hasPermission('ddd645dfa41549e386e5bebdfa58fd55')" -->
        <el-tab-pane
          :label="$t('developer.appFnSetting')"
          name="seventh"
          v-if="hasPermission('ddd645dfa41549e386e5bebdfa58fd55')"
        >
          <AppFnSetting
            :appInfo="appInfo"
            v-if="activeName === 'seventh'"
            @updateAppInfo="getAppInfo"
          ></AppFnSetting>
        </el-tab-pane>

        <el-tab-pane
          label="推送日志"
          name="eight"
          v-if="hasPermission('83670c102686445cb6cb913292c8684e')"
        >
          <pushLog
            :isTab="true"
            :appKey="appKey"
            v-if="activeName === 'eight'"
          ></pushLog>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {
  findAppInfoDetail,
  reCreatAppSecret,
  getAppSecret
} from '@/services/appManagerApi.js'
import { verifyCode } from '@/services/acountApi.js'
import { getEmailCode, sendPhoneCode } from '@/services/userCenter.js'
import dashboard from './appSetting/dashboard'
import appMessage from './appSetting/appMessage'
import appSetting from './appSetting/appSetting'
import pushDataList from './appSetting/pushDataList'
import ApiLog from './ApiLog/ApiLog'
import pushLog from './pushLog'

import DeviceCommand from '../enterpriseAdmin/deviceManager/devicesCommand'
import AppFnSetting from './appSetting/appFnSetting'
import { mapActions } from 'vuex'
import timing from '@/components/timing'
import appInfoDailog from './appSetting/appInfo'
import { getByType } from '@/cdpBase/services/dictionary.js'

export default {
  data() {
    let checkCode = (rule, value, callback) => {
      if (value) {
        let params = {
          code: value
        }
        params.loginName = this.isEmail ? this.appInfo.mail : this.appInfo.phone // 邮箱|手机
        let checkWay = this.isEmail ? 'checkEmail' : 'checkPhone'
        params.type = this.isReset ? 'resetAppSecret' : checkWay // 是否重置
        if (this.isEmail) {
          verifyCode(params)
            .then(data => {
              if (data.code === '00000000') {
                return callback()
              } else {
                return callback(new Error(data.message))
              }
            })
            .catch(e => console.log(e))
        } else {
          verifyCode(params).then(data => {
            if (data.code === '00000000') {
              return callback()
            } else {
              return callback(new Error(data.message))
            }
          })
        }
      }
    }
    return {
      title: '',
      appForm: {
        name: '',
        des: ''
      },
      appLog: '',
      activeName: 'first',
      appId: '',
      appKey: '',
      appSecret: '',
      appInfo: {},
      data: {
        appKey: '',
        lang: ''
      },
      isShow: false,
      dialogVisible: false,
      isReset: false,
      status: true, // 定时器
      codeForm: {
        code: ''
      },
      rules: {
        code: this.validatorInputEmptyRule(true, 10, checkCode)
      },
      endPoint: '',
      isEmail: false,
      isChange: false,
      email: '',
      phone: ''
    }
  },
  mounted() {
    this.appId = this.$route.query.appId
    // this.endPoint = this.$route.query.endPoint
    this.getAppInfo()
    this.getEndPoint()
  },
  beforeDestroy() {
    if (
      sessionStorage.getItem('role') === '"superadministrator"' ||
      sessionStorage.getItem('role') === '"operator"'
    ) {
      this.$root.appKey = 'all'
    }
  },
  components: {
    dashboard,
    appMessage,
    appSetting,
    pushDataList,
    ApiLog,
    DeviceCommand,
    timing,
    appInfoDailog,
    AppFnSetting,
    pushLog
  },
  methods: {
    ...mapActions(['setAppKey']),
    getEndPoint() {
      getByType('endPoint').then(data => {
        this.endPoint = data.results.results[0].value
      })
    },
    changeWay() {
      this.isEmail = !this.isEmail
    },
    toGetCode() {
      // 获取验证  手机 还是邮箱
      let params = {}
      if (this.isEmail) {
        params.email = this.appInfo.mail
      } else {
        params.phone = this.appInfo.phone
      }
      let checkWay = this.isEmail ? 'checkEmail' : 'checkPhone'
      params.type = this.isReset ? 'resetAppSecret' : checkWay // 是否重置
      if (this.isEmail) {
        getEmailCode(params)
          .then(data => {
            if (data.code === '00000000') {
              this.successMessage(this.$t('successOperation.sendEmail'))
              this.$refs.timing.beginTime()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => console.log(e))
      } else {
        sendPhoneCode(params)
          .then(data => {
            if (data.code === '00000000') {
              this.successMessage(this.$t('successOperation.sendCode'))
              this.$refs.timing.beginTime()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => this.errorMessage())
      }
    },
    closeCodeDailog() {
      this.dialogVisible = false
      this.isReset = false
      this.$refs.codeForm.resetFields()
      this.codeForm.code = ''
      this.$refs.timing.clearTimer()
    },
    submitCode() {
      // 重置密码  查看密码
      this.$refs.codeForm.validate(valid => {
        if (valid) {
          let checkWay = this.isEmail ? 'checkEmail' : 'checkPhone'
          let loginName = this.isEmail ? this.appInfo.mail : this.appInfo.phone
          if (this.isReset) {
            // 重置
            let params = {
              appKey: this.appKey,
              code: this.codeForm.code,
              loginName: loginName,
              type: checkWay
            }
            reCreatAppSecret(params)
              .then(data => {
                if (data.code === '00000000') {
                  this.successMessage(this.$t('successOperation.reset'))
                  this.closeCodeDailog()

                  this.appSecret = data.payload.results.appSecret
                  this.isShow = true
                  // }
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {
                this.errorMessage()
              })
          } else {
            // 查看密码
            this.isShow = true
            let params = {
              appKey: this.appKey,
              code: this.codeForm.code,
              loginName: loginName,
              type: checkWay
            }
            getAppSecret(params)
              .then(data => {
                if (data.code === '00000000') {
                  // // 修改appsercet为明文
                  this.closeCodeDailog()
                  this.appSecret = data.payload.results.appSecret
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {
                console.error('submitCode():', e)
              })
          }
        }
      })
    },

    showAppSecret() {
      if (!this.appInfo.phone && !this.appInfo.mail) {
        this.$message.warning(this.$t('warningOperation.hasPhoneOrEmail'))
        return
      }
      // 手机优先 邮箱垫后
      if (this.appInfo.mail && this.appInfo.phone) {
        this.isEmail = false
        this.isChange = true
      } else if (this.appInfo.mail && !this.appInfo.phone) {
        this.isEmail = true
        this.isChange = false
      }

      let params = {
        appKey: this.appKey,
        loginName: this.appInfo.mail
      }
      getAppSecret(params).then(data => {
        if (data.code === '00000000') {
          // 在5分钟内
          if (!this.isShow) {
            // 不可见
            this.isShow = true
            this.appSecret = data.payload.results.appSecret
          } else {
            // 可见
            this.isShow = false
            this.getAppInfo()
          }
        } else {
          // 不在5分钟之内
          this.dialogVisible = true
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/appManager/appList' })
    },

    resetAppSecret() {
      if (!this.appInfo.phone && !this.appInfo.mail) {
        this.$message.warning(this.$t('warningOperation.hasPhoneOrEmail'))
        return
      }

      this.dialogVisible = true
      this.isReset = true
      if (this.appInfo.mail && this.appInfo.phone) {
        this.isEmail = false
        this.isChange = true
      } else if (this.appInfo.mail && !this.appInfo.phone) {
        this.isEmail = true
        this.isChange = false
      }
    },

    editApp() {
      this.title = this.$t('developer.updateApp')
      this.$refs.appInfoDailog.isEditApp(this.appInfo)
      this.appForm.name = this.appInfo.name // 编辑时 获取信息
      this.appForm.des = this.appInfo.des
      this.$refs.appInfoDailog.showDailog()
    },
    handleAvatarSuccess(res, fileInfo) {
      if (res.code === '00000000') {
        this.appLog = res.payload.results.url
      }
    },
    uploadError() {
      this.$message.error(this.$t('common.uploadFail'))
    },
    beforeAvatarUpload(file) {
      const isJPG = ['image/jpeg', 'image/png'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error(this.$t('common.uploadCompanyLogo'))
        return false
      }
      if (!isLt2M) {
        this.$message.error(this.$t('common.uploadCompanyLogoSize'))
        return false
      }
      return isJPG && isLt2M
    },
    getAppInfo() {
      let params = {
        id: this.appId
      }
      findAppInfoDetail(params)
        .then(data => {
          if (data.code === '00000000') {
            this.appInfo = data.payload.results.dbsAppInfo
            this.email = this.emailFormat(this.appInfo.mail)
            this.phone = this.phoneFormat(this.appInfo.phone)
            this.appKey = data.payload.results.dbsAppInfo.appKey
            this.appSecret = data.payload.results.dbsAppInfo.appSecret
            this.data.appKey = this.appKey
            this.appLog = data.payload.results.dbsAppInfo.imgUrl
          }
        })
        .catch(e => {})
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.goback-bar-cla {
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 55, 103, 0.04);
  border-radius: 4px;
  border-radius: 4px;
  height: 56px;
  line-height: 56px;
  margin-bottom: 12px;
}
.appInfo_box {
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 55, 103, 0.04);
  border-radius: 4px;
  border-radius: 4px;
  height: 114px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @logoboxSize: 80px;
  padding: 10px;

  .logo-box-cla {
    width: 100%;
    display: flex;
    .logo_left_cla {
      .avatar-uploader {
        height: @logoboxSize;
        width: @logoboxSize;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover {
          border-color: @themeColor;
          .edit-header-img-cla {
            display: inline-block;
            width: 100%;
            background: #666666;
            position: absolute;
            bottom: 0px;
            left: 0px;
            height: 22px;
            .el-icon-edit {
              color: #ffffff;
            }
          }
        }
        .edit-header-img-cla {
          display: none;
          background: #666666;
          position: absolute;
          bottom: 0px;
          width: 100%;
        }
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: @logoboxSize;
        height: @logoboxSize;
        line-height: @logoboxSize;
        text-align: center;
      }
      .avatar {
        width: @logoboxSize;
        height: @logoboxSize;
        display: block;
        border-radius: 6px;
      }
    }
    .logo_right_cla {
      padding: 10px 15px;
      text-align: left;
      width: 100%;
      .app-name_cla {
        font-weight: 700;
        font-size: 16px;
      }
      .app_edit_cla {
        cursor: pointer;
        color: @themeColor;
      }
      .logo-app-des {
        color: @fontColor2;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; // 行数
      }
    }
  }

  & > div {
    height: @logoboxSize;
    width: 25%;
    box-sizing: border-box;
    background: white;
    text-align: center;
    border-right: 1px solid @secondary-color3;

    p {
      margin: 10px;
      font-weight: 700;
    }
    span {
      display: inline-block;
      word-break: break-word;
      font-size: 13px;
      padding: 0 10px;
    }
  }
  & > div:last-child {
    border-right: none;
  }

  .appKey_box {
    margin: 20px;
  }
  .appSecret_box {
    margin: 20px;
    display: flex;
    .appSecret-left {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 20%;
      i {
        cursor: pointer;
      }
    }
  }
  .endPoint_box {
    margin: 20px;
  }
}

.appDeatil {
  background-color: #ffffff;
  padding: 20px;
  .el-tabs__item {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting.vue